import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  UpdateOvertimeComponentVariables,
  UpdateOvertimeComponentResponse,
} from '../types';

const updateComponentMutation = gql`
  mutation OvertimeUpdateComponent(
    $displayName: String
    $description: String
    $status: OTSalaryComponentStatus
    $settings: OvertimeComponentSettingsInput
  ) {
    overtimeUpdateComponent(
      displayName: $displayName
      description: $description
      status: $status
      settings: $settings
    ) {
      code
      success
      message
      data {
        component {
          id
          name
          displayName
          description
          category
          isActive
          componentType
          settings {
            pfBehaviour {
              includeInPfWages
            }
            ptBehaviour {
              includeInPtWages
            }
            esiBehaviour {
              includeInEsiWages
            }
            lwfBehaviour {
              includeInLwfWages
            }
            gratuityBehaviour {
              includeInGratuityWages
            }
            leaveEncashmentBehaviour {
              includeInLeaveEncashmentWages
            }
            taxBehaviour {
              taxExemptionSection
              taxDeductionBehaviour
              taxExemptInNewRegime
              taxExemptInOldRegime
            }
            arrearBehaviour {
              considerInArrear
            }
            prorationBehaviour {
              supportProration
            }
            displayBehaviour {
              showZero
              visibleToEmployee
            }
          }
        }
      }
    }
  }
`;

const updateComponent = (variables: UpdateOvertimeComponentVariables) => {
  return graphQLApi<UpdateOvertimeComponentResponse, UpdateOvertimeComponentVariables>({
    query: updateComponentMutation,
    queryVariables: variables,
  });
};

export default updateComponent;
